module.exports = __webpack_public_path__ + "static/eos-57fc997e3dd742a6bc38b5837100ebc3.jpg";